import { render, staticRenderFns } from "./PartCovenant.vue?vue&type=template&id=45f99562&scoped=true"
import script from "./PartCovenant.vue?vue&type=script&lang=js"
export * from "./PartCovenant.vue?vue&type=script&lang=js"
import style0 from "./PartCovenant.vue?vue&type=style&index=0&id=45f99562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f99562",
  null
  
)

export default component.exports